<template>
    <div>
        <b-field>
            <template slot="label">
                <div :class="[$style.overallExportContainerLabel]">Export</div>
            </template>
            <b-dropdown
                multiple
                aria-role="list"
                :class="[$style.overallExportContainer, 'filter-dropdown']"
            >
                <button
                    class="button multi-select-button"
                    type="button"
                    slot="trigger"
                    slot-scope="{ active }"
                >
                    <span>
                        {{ selectedAnalysis.length > 0
                            ? (isAllAnalysisSelected ? 'All Analysis' : `Selected Analysis (${selectedAnalysis.length})`)
                            : 'Select Analysis'
                        }}
                    </span>
                    <b-icon
                        class="dropdown-arrow-icon-down"
                        type="is-black"
                        :icon="active? 'chevron-up' : 'chevron-down'"
                        size="is-small"
                    ></b-icon>
                </button>

                <b-dropdown-item
                    value="All Analysis"
                    class="dropdown-checkbox all-item"
                    :custom="true"
                >
                    <div class="checkbox-container">
                        <div class="column is-1 input-container width-auto">
                            <input type="checkbox" value="true" @change="updateAllSelection(false)" v-model="isAllAnalysisSelected">
                        </div>
                        <div class="column padding-none align-left">
                            <label class="break-next-line text-size-body width-full bold color-bold-text" @click="updateAllSelection(true)" :class="$style.applyMargin">
                                All Analysis
                            </label>
                        </div>
                    </div>
                </b-dropdown-item>

                <b-dropdown-item
                    :value="value.title"
                    aria-role="listitem"
                    v-for="(value, index) in totalAnalysis"
                    :key="index"
                    :class="[$style.dropdownItem, 'dropdown-checkbox']"
                    :custom="true"
                >
                    <div class="checkbox-container">
                        <div class="column is-1 input-container width-auto">
                            <input type="checkbox" :value="value.analysisId" @change="updateSelection(false, value.analysisId)" v-model="selectedAnalysis">
                        </div>
                        <div class="column padding-none align-left" >
                            <label class="break-next-line text-size-body" @click="updateSelection(true, value.analysisId)">
                                <span class="break-next-line text-size-body width-full margin-bottom5">{{value.title}}</span>
                            </label>
                        </div>
                    </div>
                </b-dropdown-item>
            </b-dropdown>
        </b-field>
    </div>
</template>

<script lang="ts">
    import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
    import { cloneDeep as _cloneDeep } from 'lodash';

    @Component({ components : {} })

    export default class ProjectReportExportFilter extends Vue {
        @Prop()
        public totalAnalysis!: any[];
        public selectedAnalysis: number[] = [];
        public isAllAnalysisSelected: boolean = true;
        public allAnalysisIds: number[] = [];

        public mounted() {
            this.populateData();
        }

        public populateData() {
          this.totalAnalysis.map((analysis: any) => {
            this.selectedAnalysis.push(analysis.analysisId);
          });
          this.allAnalysisIds = _cloneDeep(this.selectedAnalysis);
        }

        public updateSelection(label: boolean = false, analysisId: number) {
            if (label) {
                const analysisIndex = this.selectedAnalysis.indexOf(analysisId);
                if (analysisIndex === -1) {
                    this.selectedAnalysis.push(analysisId);
                } else {
                    this.selectedAnalysis.splice(analysisIndex, 1);
                }
            }
            this.isAllAnalysisSelected = this.allAnalysisIds.length === this.selectedAnalysis.length;
            this.emitAnalysisFilter();
        }

        public updateAllSelection(label: boolean = false) {
            if (label) {
                this.isAllAnalysisSelected = !this.isAllAnalysisSelected;
            }
            if (this.isAllAnalysisSelected) {
                this.selectedAnalysis = _cloneDeep(this.allAnalysisIds);
            } else {
                this.selectedAnalysis = [];
            }
            this.emitAnalysisFilter();
        }

        public emitAnalysisFilter() {
          this.$emit('applyOverallExportAnalysisFilter', this.selectedAnalysis);
        }
    }
</script>
<style lang="scss" module scoped>
    .applyMargin {
        margin-left: -2px;
    }
    .overallExportContainer {
        width: 512px;
    }
    .overallExportContainerLabel {
        color: #444f51;
        font-weight: bold;
        font-size: 14px;
    }
    .dropdownItem {
        border-bottom: 0.5px solid #DBDBDB;
    }
    .dropdownItem:last-child {
        border-bottom: unset;
    }
</style>
